// extracted by mini-css-extract-plugin
export default {"wrapper":"A_Reaction_wrapper__sPOfY","medium":"A_Reaction_medium__3Wpse","large":"A_Reaction_large__UQP9t","image":"A_Reaction_image__CcMNC"};